export default [
  {
    uri:"member/sign-in",
    options: {
      needAuth: false
    }
  },
  {
    uri:"meter/list",
    options: {
      needAuth: true
    }
  },
  {
    uri:"order/list",
    options: {
      needAuth: true
    }
  },
  {
    uri:"order/create",
    options: {
      needAuth: true
    }
  },
  {
    uri:"order/get-paytype",
    options: {
      needAuth: true
    }
  },
  {
    uri:"order/success-order",
    options: {
      needAuth: true
    }
  },
  {
  	uri:"order/order-info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"member/edit-password",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"member/sign-out",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/add",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/edit",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/delete",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/get-meter-list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/edit-meter-list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/edit-password",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/get-power-list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"admin/edit-power-list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"order/over-draft",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"count/meter-charge",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"count/meter-status",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/plan-list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/add",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/ban",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/reset",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"file/edit",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"count/home-page",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"receipt/list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"receipt/info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"receipt/edit",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"order/get-status",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"member/get-nature",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/create",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/delete",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/addAccount",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/create",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/detail",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"treceipt/info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"treceipt/create",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"treceipt/list",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"treceipt/delete",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"treceipt/addAccount",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"treceipt/detail",
  	options:{
  		needAuth:true
  	}
  },
   {
  	uri:"lift/detail",
  	options:{
  		needAuth:true
  	}
  },
   {
  	uri:"refund/get-time",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"refund/list",
  	options:{
  		needAuth:true
  	}
  },
   {
  	uri:"refund/auditing",
  	options:{
  		needAuth:true
  	}
  },
   {
  	uri:"refund/info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"authority/pay",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"upgrade/getPolling",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"upgrade/getList",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"upgrade/info",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"upgrade/readMessage",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/getAccountInfo",
  	options:{
  		needAuth:true
  	}
  },
  {
  	uri:"lift/agreement",
  	options:{
  		needAuth:true
  	}
  },
  
	// loong  
	{
		uri:"ystair/is-annual",
		options:{
			needAuth:true
		}
	},
	{
		uri:"ystair/pay-tip",
		options:{
			needAuth:true
		}
	},
	{
		uri:"ystair/year-create",
		options:{
			needAuth:true
		}
	},
	{
		uri:"ystair/pocket-list",
		options:{
			needAuth:true
		}
	},
	{
		uri:"order/order-info",
		options:{
			needAuth:true
		}
	},

	// 户号管理
	{
		uri:"account/list",
		options:{
			needAuth:true
		}
	},
	{
		uri:"account/reset-pass",
		options:{
			needAuth:true
		}
	},
	{
		uri:"account/detail",
		options:{
			needAuth:true
		}
	},
	{
		uri:"account/edit",
		options:{
			needAuth:true
		}
	},

	// 物业缴费
	{
		uri:"property/list",
		options:{
			needAuth:true
		}
	},
	{
		uri:"property/get_info",
		options:{
			needAuth:true
		}
	},
	{
		uri:"property/import",
		options:{
			needAuth:true
		}
	},
	{
		uri:"property/add-time",
		options:{
			needAuth:true
		}
	},
	{
		uri:"property/edit_time",
		options:{
			needAuth:true
		}
	},
	{
		uri:"property/get-temp-url",
		options:{
			needAuth:true
		}
	},

	{
		uri:"property/del-info",
		options:{
			needAuth:true
		}
	},

	{
		uri:"property/add-info",
		options:{
			needAuth:true
		}
	},

	{
		uri:"property/edit-info",
		options:{
			needAuth:true
		}
	},
	{
		uri:"property/get-account",
		options:{
			needAuth:true
		}
	},

	// 小区列表
	{
		uri:"invoice/list",
		options:{
			needAuth:true
		}
	},
	// 小区状态
	{
		uri:"invoice/edit",
		options:{
			needAuth:true
		}
	},

	// 物业缴费提现 - 获取
	{
		uri:"property_lift/info",
		options:{
			needAuth:true
		}
	},
	// 物业缴费提现 - 提交
	{
		uri:"property_lift/create",
		options:{
			needAuth:true
		}
	},
	// 物业缴费提现 - 服务协议
	{
		uri:"property_lift/agreement",
		options:{
			needAuth:true
		}
	},

	// 物业缴费记录 - 获取
	{
		uri:"property_lift/list",
		options:{
			needAuth:true
		}
	},
	// 物业缴费记录 - 详情
	{
		uri:"property_lift/detail",
		options:{
			needAuth:true
		}
	},

	// 申请手续费发票 - 获取
	{
		uri:"property_treceipt/info",
		options:{
			needAuth:true
		}
	},
	// 申请手续费发票 - 添加用户
	{
		uri:"property_treceipt/addAccount",
		options:{
			needAuth:true
		}
	},
	// 申请手续费发票 - 提交
	{
		uri:"property_treceipt/create",
		options:{
			needAuth:true
		}
	},

	// 发票列表 - 获取
	{
		uri:"property_treceipt/list",
		options:{
			needAuth:true
		}
	},
	// 发票列表 - 详情
	{
		uri:"property_treceipt/detail",
		options:{
			needAuth:true
		}
	},

	// 账户明细
	{
		uri:"property_lift/getAccountInfo",
		options:{
			needAuth:true
		}
	},
]


// WEBPACK FOOTER //
// ./src/jssdk/apiList.js